import { useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/ApiUrl";
import CreateDispute from "../write/createDispute";
import Allowance from "../read/approveAllowance";
import Environment from "../../utils/Environment";
import axios from "axios";
import TaskDisputedDetails from "./taskDisputedDetails";
import CustomToast from '../../components/CustomToast';
import { uploadProofOnIPFS } from "../IPFS/UploadProofOnIPFS";


const useCreateDispute = (id, account, taskData, setLoader, fetchTaskData) => {

    // console.log(id, account, taskData, setLoader, fetchTaskData, "DisputeSign 666 all args");

    const { AllowanceCore } = Allowance();
    const { taskDisputedDetailsHook } = TaskDisputedDetails();
    const { createDisputeHook } = CreateDispute();

    const [disputeSign, setDisputeSign] = useState(null);
    // const [createDisputeContractRes, setCreateDisputeContractRes] = useState(null);

    const getAuthConfig = () => {
        const accessToken = localStorage.getItem("accessToken");
        return accessToken
            ? { headers: { Authorization: `Bearer ${accessToken}` } }
            : {};
    };

    const handleDisputeSign = async (creatorIpfsURI) => {
        // debugger
        try {

            // const payload = {
            //     ipfsUrl: proofIpfsHash, winnerIpfsUrl: taskData?.participants[0]?.proofIpfsHash
            // }
            // console.log(payload, "payloadpayloadpayloadpayload");


            setLoader(true);
            const config = getAuthConfig(); // Fetch auth config
            const res = await axios?.post(`${API_URL}tasks/${id}/signature/task-dispute`, { ipfsUrl: taskData?.participation?.proofIpfsHash, winnerIpfsUrl: creatorIpfsURI ? `ipfs://${creatorIpfsURI}/` : taskData?.participants[0]?.proofIpfsHash }, config);
            setDisputeSign(res?.data?.data?.signedKeyDetails);
            console.log(res, "ressss DisputeSign 1 disputeSigndisputeSigndisputeSign");
            if (res) {
                console.log(res?.data?.data?.signedKeyDetails, "DisputeSign 2 disputeSigndisputeSigndisputeSign ifff");
                return res?.data?.data?.signedKeyDetails;
            } else {
                // toast?.error("getting error in disput sign");
                CustomToast.show('error', 'Error!', 'Error getting dispute signature')
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
            // toast?.error(error);
            CustomToast.show('error', 'Error!', `Error creating dispute: ${error.message}`);
        }
    }

    const createDispute = async (close_Dispute_Confirmation_Modal) => {
        if (!account) {
            // toast.warning("Please connect your wallet!");

            CustomToast.show('warning', 'Warning!', 'Please connect your wallet to create a dispute')

            return;
        }
        setLoader(true);

        try {
            console.log(taskData?.contractTaskId, 'taskData?.contractTaskId');
            let TOTAL_DISPUTE_AMOUNT =  taskData?.disputeType === 'mini' ? 2 : 4; // 1.5 for mini dispute, 4 for regular dispute

            // Approve USDT allowance  
            // regularDispute,

            try {
                const disputeContractRes = await taskDisputedDetailsHook(taskData?.contractTaskId);
                console.log(disputeContractRes, "AllowanceCore disputeContractRes Winnner adddress");

                if (disputeContractRes && disputeContractRes?.disputeContract == '0x0000000000000000000000000000000000000000') {
                    console.log("AllowanceCore, in null", taskData);
                    // taskData?.reward <= 10
                    await AllowanceCore(taskData?.disputeType === 'mini' ? Environment?.miniDispute : Environment?.regularDispute, Environment?.USDT, TOTAL_DISPUTE_AMOUNT, 6, "USDT");
                } else {
                    console.log("AllowanceCore without nulll");

                    await AllowanceCore(disputeContractRes?.disputeContract, Environment?.USDT, TOTAL_DISPUTE_AMOUNT, 6, "USDT");
                }

            } catch (contractError) {
                console.error("Contract Error:", contractError);
                // toast.error("Contract approval failed: " + contractError.message);
                CustomToast.show('error', 'Error!', 'Contract approval failed: ' + contractError.message)
                setLoader(false);
                return;
            }

            // Create dispute on-chain
            // let disputeSignRes;
            // console.log(disputeSignRes, "disputeSignRes")

            // if (disputeSignRes) {
            try {
                console.log("start disputeTask...., disputeSign DisputeSign 4", disputeSign);
                setLoader(true);
                let res;
                if (taskData?.winnerSelected == false) {
                    console.log("iin iffff winnerSelected");

                    const ressss = await uploadProofOnIPFS(account, taskData, null, null);
                    console.log(ressss, "ressssressssressss winnerSelected");
                    if (ressss) {
                        const disputeSignRes = await handleDisputeSign(ressss);
                        if (disputeSignRes) {
                            res = await createDisputeHook(disputeSignRes, taskData, ressss);
                        }
                    }
                } else {
                    console.log("in elssss winnerSelected");
                    const disputeSignRes = await handleDisputeSign();
                    if (disputeSignRes) {
                        res = await createDisputeHook(disputeSignRes, taskData);
                    }
                }

                console.log(res, "res in createDisputeHook");
                // setCreateDisputeContractRes(res);
                if (res) {
                    // Call backend API to register dispute
                    console.log(res?.transactionHash, "res?.transactionHash", taskData?.contractTaskId, "taskData?.taskId", "API to register dispute");

                    const accessToken = localStorage.getItem('accessToken');
                    const response = await fetch(`${API_URL}tasks/${id}/dispute`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`,
                        },
                        body: JSON.stringify({
                            transactionHash: res?.transactionHash,
                            contractTaskId: taskData?.contractTaskId
                        }),
                    });

                    if (!response.ok) {
                        const errorMessage = await response.text();
                        throw new Error(errorMessage || 'Failed to create dispute');
                    }

                    // toast.success('Dispute created successfully');

                    CustomToast.show('success', 'Success!', 'Dispute created successfully')

                    setLoader(false);
                    close_Dispute_Confirmation_Modal();
                    fetchTaskData();

                    setLoader(false);
                }
            } catch (contractError) {
                console.error("Contract Error:", contractError);
                // toast.error("Dispute creation on-chain failed: " + contractError.message);
                CustomToast.show('error', 'Error!', 'Dispute creation on-chain failed: ' + contractError.message)


                setLoader(false);
                return;
            }
            // }

        } catch (error) {
            console.error("API Error:", error);
            // toast.error("API request failed: " + error.message);
            CustomToast.show('error', 'Error!', 'API request failed: ' + error.message)

            setLoader(false);
        }
        finally {
            setLoader(false);
        }
    };

    return { createDispute };
};

export default useCreateDispute;
